<template>
  <card
    class="player-card"
    :bodyClasses="['body', {'closed': !expanded}]"
    shadow
  >
    <div slot="header" class="row">
      <div class="col d-flex align-items-center" @click="expanded = !expanded">
        <h3 class="mb-0" v-if="match.teams.length <= 0">
          New Match
        </h3>
        <h3 class="mb-0" v-if="match.teams.length >= 1">
          {{match.teams[0].Name}} <span class="light-text"><i> vs. </i></span>
          {{match.teams.length >= 2 ? match.teams[1].Name : ''}}
        </h3>
        <badge :type="status.type" class="status-badge">{{status.text}}</badge>
      </div>
      <div class="col-auto text-right d-flex align-items-center justify-content-end">
        <div class="button-area" v-if="!loading">
          <base-button
            type="danger"
            size="sm"
            @click="discard"
            v-if="status.text === 'UNSAVED'"
          >
            Discard
          </base-button>
          <base-button
            type="success"
            size="sm"
            @click="save"
            v-if="status.text === 'UNSAVED'"
          >
            Save
          </base-button>


        </div>
        <div class="loader" v-if="loading">
          Loading
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <i class="fa fa-chevron-down" v-if="!expanded" @click="expanded = !expanded"/>
        <i class="fa fa-chevron-up" v-else @click="expanded = !expanded"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h3>Winning Team <small>(select one)</small></h3>
      </div>
      <div class="col-md-6" v-for="team in match.teams" :key="team.id">
        <TeamScheduleCard
          class="team-winner-option"
          :team="team"
          :selected="team.id === model.winningTeam"
          @click.native="setWinningTeam(team.id)"
          shadow
          :week="week"
        />
      </div>
    </div>

    <div class="row" v-for="team in teams" :key="team.id">
      <div class="col-md-12">
        <h3 class="mt-3">{{team.Name}} Stats</h3>
      </div>
      <div class="col-md-2">
        <base-input
          label="Gross"
          v-model="model.teamScorecards[team.id].gross"
          input-classes="form-control-alternative"
          type="number"
        />
      </div>
      <div class="col-md-2" v-if="league.showCTP">
        <base-input
          label="CTP"
          v-model="model.teamScorecards[team.id].closest_to_pin"
          input-classes="form-control-alternative"
          type="number"
        />
      </div>
      <div class="col-md-3" v-if="league.showCTP">
        <base-input
          label="Player"
        >
          <MultiselectReturnId
            v-model="model.teamScorecards[team.id].ctp_player"
            :options="team.players"
            class="shadow"
            track-by="id"
            label="Name"
            selectLabel=""
            deselectLabel=""
          />
        </base-input>
      </div>
      <div class="col-md-2" v-if="league.showLD">
        <base-input
          label="Longest Drive"
          v-model="model.teamScorecards[team.id].long_drive"
          input-classes="form-control-alternative"
          type="number"
        />
      </div>
      <div class="col-md-3" v-if="league.showLD">
        <base-input
          label="Player"
        >
          <MultiselectReturnId
            v-model="model.teamScorecards[team.id].ld_player"
            :options="team.players"
            class="shadow"
            track-by="id"
            label="Name"
            selectLabel=""
            deselectLabel=""
          />
        </base-input>
      </div>
      <div class="col-md-12">
        <base-input
          label="Note"
          v-model="model.teamScorecards[team.id].note"
          input-classes="form-control-alternative"
        />
      </div>
    </div>

  </card>
</template>
<script>
import TeamScheduleCard from '@/components/TeamScheduleCard.vue';
import MultiselectReturnId from '@/components/MultiselectReturnId.vue';
import ErrorHandler from '@/helpers/AuthError';

export default {
  name: 'MatchScoreCard',
  components: {
    TeamScheduleCard,
    MultiselectReturnId,
  },
  props: {
    match: Object,
    week: Object,
    league: Object,
  },
  data() {
    return {
      expanded: true,
      model: {
        winningTeam: null,
        teamScorecards: {},
      },
      emptyTeamScorecard: {
        gross: '',
        closest_to_pin: '',
        long_drive: '',
        note: '',
        ctp_player: null,
        ld_player: null,
      },
      originalState: {

      },
      teams: [],
      playerProfiles: [],
      loading: false,
    };
  },
  computed: {
    editing() {
      if (
        this.model.winningTeam !== this.originalState.winningTeam
        || !this.compareTeamScorecards(this.model.teamScorecards, this.originalState.teamScorecards)
      ) {
        return true;
      }
      return false;
    },
    status() {
      if (this.editing) {
        return {
          text: 'UNSAVED',
          type: 'info',
        };
      }
      if (this.match.scorecards.length <= 0) {
        return {
          text: 'NO SCORE',
          type: 'secondary',
        };
      }
      if (this.match.scorecards.length < 2) {
        return {
          text: 'INCOMPLETE',
          type: 'secondary',
        };
      }

      return {
        text: 'COMPLETE',
        type: 'success',
      };
    },
  },
  watch: {
    match() {
      console.log('Match Updated', this.match);
      if (!this.editing) {
        this.generateScorecards();
        this.setOriginalStateToModel();
      }
    },
    status() {
      if (this.status.text === 'COMPLETE') {
        this.expanded = false;
      }
    },
  },
  mounted() {
    this.getTeams();
    this.generateScorecards();
    this.setOriginalStateToModel();
  },
  methods: {
    getTeams() {
      return this.axios
        .get(`/teams?matches_in=${this.match.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(response => this.getPlayerProfiles(response.data))
        .then((result) => {
          const { teams } = result;

          teams.forEach((team, index) => {
            const playerProfiles = [];
            const players = [];

            result.profiles.forEach((profile) => {
              if (profile.team && (profile.team.id === team.id)) {
                playerProfiles.push(profile);
                players.push(profile.user);
              }
            });

            teams[index].player_profiles = playerProfiles;
            teams[index].players = players;
          });
          this.teams = teams;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getPlayerProfiles(teams) {
      const teamQueries = [];
      this.teams.forEach((team) => {
        teamQueries.push(`team_eq=${team.id}`);
      });
      const teamQueryString = teamQueries.join('&');
      return this.axios
        .get(`/teamprofiles?${teamQueryString}&_limit=-1`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.playerProfiles = response.data;
          return { profiles: response.data, teams };
        });
    },
    save() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const saveJobs = [];
      this.match.teams.forEach((team) => {
        if (this.model.teamScorecards[team.id].id !== null) {
          saveJobs.push(this.updateScorecard(this.model.teamScorecards[team.id].id, {
            gross: parseFloat(this.model.teamScorecards[team.id].gross),
            closest_to_pin: parseFloat(this.model.teamScorecards[team.id].closest_to_pin),
            long_drive: parseFloat(this.model.teamScorecards[team.id].long_drive),
            ctp_player: this.model.teamScorecards[team.id].ctp_player,
            ld_player: this.model.teamScorecards[team.id].ld_player,
            note: this.model.teamScorecards[team.id].note,
            win: this.model.winningTeam === team.id,
            week: this.week.id,
            league: this.league.id,
            team: team.id,
            match: this.match.id,
          }));
        } else {
          saveJobs.push(this.createNewScorecard({
            gross: parseFloat(this.model.teamScorecards[team.id].gross),
            closest_to_pin: parseFloat(this.model.teamScorecards[team.id].closest_to_pin),
            long_drive: parseFloat(this.model.teamScorecards[team.id].long_drive),
            ctp_player: this.model.teamScorecards[team.id].ctp_player,
            ld_player: this.model.teamScorecards[team.id].ld_player,
            note: this.model.teamScorecards[team.id].note,
            win: this.model.winningTeam === team.id,
            week: this.week.id,
            league: this.league.id,
            team: team.id,
            match: this.match.id,
          }));
        }
      });

      Promise.all(saveJobs)
        .then(() => {
          this.setOriginalStateToModel();
          this.$emit('saved');
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          window.location.reload();
        });
    },
    discard() {
      this.setModelToOriginalState();
    },
    createNewScorecard(scorecard) {
      return this.axios
        .post('/scorecards', scorecard, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.$emit('saved');
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    updateScorecard(id, scorecard) {
      return this.axios
        .put(`/scorecards/${id}`, scorecard, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.$emit('saved');
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    compareTeamScorecards(currentCards, originalCards) {
      let isEqual = true;
      this.match.teams.forEach((team) => {
        if (!this.compareObjectKeys(currentCards[team.id], originalCards[team.id])) {
          isEqual = false;
        }
      });
      return isEqual;
    },
    compareObjectKeys(newObj, oldObj) {
      let isEqual = true;
      Object.keys(oldObj).forEach((key) => {
        // using != instead of !== because the types don't always match but we still want
        // to catch matching objects (25 == '25')
        // eslint-disable-next-line eqeqeq
        if (oldObj[key] != newObj[key]) {
          isEqual = false;
        }
      });
      return isEqual;
    },
    setWinningTeam(id) {
      if (this.model.winningTeam === id) {
        this.model.winningTeam = null;
      } else {
        this.model.winningTeam = id;
      }
    },
    generateScorecards() {
      const newScorecards = {};
      this.match.teams.forEach((team) => {
        const foundCard = this.matchHasTeamScorecard(team.id, this.match.scorecards);

        if (foundCard !== null) {
          if (foundCard.win) {
            this.model.winningTeam = team.id;
          }
          newScorecards[team.id] = {
            gross: foundCard.gross,
            closest_to_pin: foundCard.closest_to_pin,
            long_drive: foundCard.long_drive,
            ctp_player: foundCard.ctp_player,
            ld_player: foundCard.ld_player,
            note: foundCard.note,
            id: foundCard.id,
          };
        } else {
          newScorecards[team.id] = {
            ...this.emptyTeamScorecard,
            id: null,
          };
        }
      });
      this.model.teamScorecards = newScorecards;
    },
    matchHasTeamScorecard(teamId, scorecards) {
      let foundCard = null;
      scorecards.forEach((card) => {
        if (card.team === teamId) {
          foundCard = card;
        }
      });
      return foundCard;
    },
    setOriginalStateToModel() {
      this.originalState = JSON.parse(JSON.stringify(this.model));
    },
    setModelToOriginalState() {
      this.model = JSON.parse(JSON.stringify(this.originalState));
    },
  },
  sockets: {
    updated_match_scorecard(value) {
      if (value.week.id === this.week.id && value.match.id === this.match.id) {
        this.$emit('updated');
        this.getTeams();
        this.generateScorecards();
        this.setOriginalStateToModel();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .loader{
    text-transform: uppercase;
    font-size: .9rem;
    font-weight: 600;
    opacity: .6;
    padding-right: .5rem;
  }
  .player-card{
    overflow: hidden;
  }
  .status-badge{
    margin-left: 1rem;
    margin-top: .2rem;
  }
  .button-area{
    margin-right: 1rem;
  }
  .team-winner-option{
    cursor: pointer;
    margin-bottom: 1rem;
  }
</style>
<style lang="scss">
  .body{
    transition: all .15s;
  }
  .closed{
    height: 0;
    opacity: 0;
    visibility: none;
    padding: 0;
  }

</style>
